function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import styles from "./RegularButton.module.sass";
import Icon from "../../Icon/Icon";
const RegularButton = ({
  children,
  iconClassName,
  className,
  primary,
  warning,
  danger,
  icon,
  customizeButton,
  ...attributes
}) => /*#__PURE__*/React.createElement("button", _extends({
  className: `${styles["button"]} ${className || ""}`
}, attributes, {
  primary: primary ? "true" : "false",
  warning: warning ? "true" : "false",
  danger: danger ? "true" : "false",
  style: customizeButton ? {
    border: "none",
    boxShadow: "none",
    opacity: "0.8"
  } : {}
}), icon && /*#__PURE__*/React.createElement(Icon, {
  className: `${customizeButton ? `${styles[`${customizeButton}`]} ${iconClassName || ""}` : `${styles["icon"]} ${iconClassName || ""}`}`,
  name: icon
}), children && /*#__PURE__*/React.createElement("small", {
  className: `${customizeButton ? styles["icon-text-color"] : ""}`
}, /*#__PURE__*/React.createElement("strong", null, children)));
export default RegularButton;